import { useCurrentTime } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { getTimezoneName, groupedFilteredTimezones } from '@calendly/timezone-tools';
import { TimezoneContainer, TimezoneFilter, TimezoneList, TimezoneTitle } from '@calendly/timezone-tools/timezone-picker';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { Icon } from '@calendly/ui/components/icon';
import { Item, Group } from '@calendly/ui/components/menu';
import { LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { timeNotationSelector } from 'selectors/current_user';
const containerCss = "c3ukvd2";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const timezoneToggleAlternateStylingCss = "tqjkn6c";
const timezoneToggleToggledCss = "t10vxbxl";
const timezoneToggleRightAlignedCss = "t14f1286";
const timezoneToggleCss = "t1bk8scu";
const TimezoneToggle = forwardRef((props, ref) => {
  const {
    alternateStyling,
    toggled,
    rightAligned,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(timezoneToggleCss, {
    [timezoneToggleAlternateStylingCss]: alternateStyling,
    [timezoneToggleToggledCss]: toggled,
    [timezoneToggleRightAlignedCss]: rightAligned
  }, props.className)} />;
});
const styledDropdownIconCss = "scuhcag";
const StyledDropdownIcon = forwardRef((props, ref) => <Icon ref={ref} {...props} className={classNames(styledDropdownIconCss, props.className)} />);
const styledTimezoneContainerRightAlignedCss = "sduvwzu";
const styledTimezoneContainerCss = "s8k7g1z";
const StyledTimezoneContainer = forwardRef((props, ref) => {
  const {
    rightAligned
  } = props;
  return <TimezoneContainer ref={ref} {...props} className={classNames(styledTimezoneContainerCss, {
    [styledTimezoneContainerRightAlignedCss]: rightAligned
  }, props.className)} />;
});
const styledTimezoneListCss = "s10z5hh8";
const StyledTimezoneList = forwardRef((props, ref) => <TimezoneList ref={ref} {...props} className={classNames(styledTimezoneListCss, props.className)} />);
const scrollContainerCss = "sj8l0fg";
const ScrollContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(scrollContainerCss, props.className)} />;
});
const titleWrapperCss = "tmgwkxb";
const TitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleWrapperCss, props.className)} />;
});
const styledItemSelectedCss = "s1j44cgx";
const styledItemCss = "s10ff19f";
const StyledItem = forwardRef((props, ref) => {
  const {
    selected
  } = props;
  return <Item ref={ref} {...props} className={classNames(styledItemCss, {
    [styledItemSelectedCss]: selected
  }, props.className)} />;
});
export default ({
  timezone,
  onSelectTimezone,
  defaultOptionLabel,
  rightAligned = false,
  alternateStyling = false,
  menuLayerStyle,
  ...props
}) => {
  const [toggle, Dropdown, isOpen] = useDropdown();
  const [filterTerm, setFilterTerm] = useState('');
  const currentTime = useCurrentTime();
  const timeNotation = useSelector(timeNotationSelector);
  const timezones = groupedFilteredTimezones(filterTerm);
  return <Container>
      <TimezoneToggle onClick={event => toggle(event)} toggled={isOpen} aria-controls="timezone-picker-dropdown" aria-expanded={isOpen} alternateStyling={alternateStyling} rightAligned={rightAligned} {...props}>
        <LabelText size="large">{timezone ? getTimezoneName(timezone) : defaultOptionLabel}</LabelText>
        <StyledDropdownIcon name={isOpen ? 'angle-up' : 'angle-down'} />
      </TimezoneToggle>
      <Dropdown>
        <StyledTimezoneContainer id="timezone-picker-dropdown" data-component="timezone-picker" rightAligned={rightAligned} {...menuLayerStyle && {
        style: menuLayerStyle,
        mobileMenuStyle: menuLayerStyle
      }}>
          <TimezoneFilter value={filterTerm} onChange={setFilterTerm} />
          <ScrollContainer>
            <Group>
              {defaultOptionLabel && <StyledItem selected={!timezone} onClick={() => onSelectTimezone(null)}>
                  {defaultOptionLabel}
                </StyledItem>}
              <TitleWrapper>
                <TimezoneTitle>{I18n.t('timezones.time_zone')}</TimezoneTitle>
              </TitleWrapper>
              <StyledTimezoneList timezones={timezones} time={currentTime} timeNotation={timeNotation} selectedId={timezone} onSelect={onSelectTimezone} />
            </Group>
          </ScrollContainer>
        </StyledTimezoneContainer>
      </Dropdown>
    </Container>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.js");